import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Divider } from './components/Divider';
import { ProductSection } from './components/ProductSection';
import { ArtifactSection } from './components/ArtifactSection';
import { BonusSection } from './components/BonusSection';
import { ProofSection } from './components/ProofSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { FooterCta } from './components/FooterCta';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="max-w-[480px] mx-auto bg-cream min-h-screen relative shadow-2xl" data-id="element-0">
      <div id="hero" data-id="element-1">
        <Hero data-id="element-2" />
      </div>
      <PainSection data-id="element-3" />
      <Divider data-id="element-4" />
      <ProductSection data-id="element-5" />
      <ArtifactSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <FooterCta data-id="element-11" />
      <StickyCta data-id="element-12" />
    </div>;
}